import React from "react";

import {
  FiDollarSign,
  FiEye,
} from "react-icons/fi";

import {
  FaSpinner,
} from "react-icons/fa";

import EmployeePagination
  from "../common/EmployeePagination";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeCurrency,
  formatEmployeeLabel,
} from "../utils/employee.utils";

import "./EmployeeSalary.css";


const EmployeeSalaryTable = ({
  records = [],

  loading = false,

  page = 1,

  limit = 10,

  totalRecords = 0,

  totalPages = 1,

  onPageChange,

  onLimitChange,

  onView,

  onPay,
}) => {

  if (
    loading
  ) {

    return (

      <div className="employee-salary-loading">

        <FaSpinner />

        <span>
          Loading salary records...
        </span>

      </div>

    );

  }


  return (

    <section className="employee-salary-table-card">

      <div className="employee-salary-table-heading">

        <div>

          <span>
            PAYROLL
          </span>

          <h2>
            Salary Records
          </h2>

          <p>
            Monthly generated salary and payment status.
          </p>

        </div>

      </div>


      <div className="employee-salary-table-scroll">

        <table className="employee-salary-table">

          <thead>

            <tr>

              <th>
                #
              </th>

              <th>
                Employee
              </th>

              <th>
                Period
              </th>

              <th>
                Basic
              </th>

              <th>
                Allowances
              </th>

              <th>
                Deductions
              </th>

              <th>
                Net Salary
              </th>

              <th>
                Paid
              </th>

              <th>
                Balance
              </th>

              <th>
                Status
              </th>

              <th>
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            {
              records.length ===
              0
                ?
                (
                  <tr>

                    <td
                      colSpan="11"
                      className="employee-salary-empty"
                    >

                      <FiDollarSign />

                      <strong>
                        No salary records found
                      </strong>

                      <span>
                        Generate salary for the selected payroll period.
                      </span>

                    </td>

                  </tr>
                )
                :
                records.map(
                  (
                    salary,
                    index
                  ) => {

                    const employee =
                      salary?.employeeId &&
                      typeof salary.employeeId ===
                        "object"
                        ?
                        salary.employeeId
                        :
                        salary?.employee ||
                        {};


                    const basicSalary =
                      Number(
                        salary?.basicSalary ??
                        salary
                          ?.salary
                          ?.basicSalary ??
                        0
                      );


                    const allowances =
                      Number(
                        salary?.allowances ??
                        salary
                          ?.salary
                          ?.allowances ??
                        0
                      );


                    const deductions =
                      Number(
                        salary?.deductions ??
                        salary
                          ?.salary
                          ?.deductions ??
                        salary?.totalDeduction ??
                        0
                      );


                    const netSalary =
                      Number(
                        salary?.netSalary ??
                        salary
                          ?.salary
                          ?.netSalary ??
                        salary?.payableAmount ??
                        0
                      );


                    const paidAmount =
                      Number(
                        salary?.paidAmount ??
                        0
                      );


                    const balanceAmount =
                      Number(
                        salary?.balanceAmount ??
                        Math.max(
                          netSalary -
                          paidAmount,
                          0
                        )
                      );


                    const paymentStatus =
                      salary?.paymentStatus ||
                      salary?.status ||
                      (
                        balanceAmount <=
                        0
                          ?
                          "PAID"
                          :
                          paidAmount >
                          0
                            ?
                            "PARTIALLY_PAID"
                            :
                            "UNPAID"
                      );


                    const month =
                      Number(
                        salary?.month ??
                        salary?.salaryMonth ??
                        0
                      );


                    const year =
                      salary?.year ??
                      salary?.salaryYear ??
                      "-";


                    const monthLabel =
                      month >=
                        1 &&
                      month <=
                        12
                        ?
                        new Date(
                          2000,
                          month -
                          1,
                          1
                        )
                          .toLocaleString(
                            "en-IN",
                            {
                              month:
                                "short",
                            }
                          )
                        :
                        "-";


                    return (

                      <tr
                        key={
                          salary?._id ||
                          `${index}-${year}-${month}`
                        }
                      >

                        <td>
                          {
                            (
                              Number(
                                page
                              ) -
                              1
                            ) *
                            Number(
                              limit
                            ) +
                            index +
                            1
                          }
                        </td>


                        <td>

                          <div className="employee-salary-person">

                            <strong>
                              {
                                employee?.name ||
                                salary?.employeeName ||
                                "-"
                              }
                            </strong>

                            <span>
                              {
                                employee?.employeeCode ||
                                salary?.employeeCode ||
                                "-"
                              }
                            </span>

                          </div>

                        </td>


                        <td>

                          <strong>
                            {monthLabel}
                            {" "}
                            {year}
                          </strong>

                        </td>


                        <td>
                          {
                            formatEmployeeCurrency(
                              basicSalary
                            )
                          }
                        </td>


                        <td>
                          {
                            formatEmployeeCurrency(
                              allowances
                            )
                          }
                        </td>


                        <td>
                          {
                            formatEmployeeCurrency(
                              deductions
                            )
                          }
                        </td>


                        <td>

                          <strong className="employee-salary-net-value">
                            {
                              formatEmployeeCurrency(
                                netSalary
                              )
                            }
                          </strong>

                        </td>


                        <td>
                          {
                            formatEmployeeCurrency(
                              paidAmount
                            )
                          }
                        </td>


                        <td>

                          <strong
                            className={
                              balanceAmount >
                              0
                                ?
                                "employee-salary-balance pending"
                                :
                                "employee-salary-balance paid"
                            }
                          >
                            {
                              formatEmployeeCurrency(
                                balanceAmount
                              )
                            }
                          </strong>

                        </td>


                        <td>

                          <EmployeeStatusBadge
                            status={
                              paymentStatus
                            }
                          />

                        </td>


                        <td>

                          <div className="employee-salary-actions">

                            <button
                              type="button"
                              onClick={
                                () =>
                                  onView?.(
                                    salary
                                  )
                              }
                              title="View Details"
                            >

                              <FiEye />

                            </button>


                            <button
                              type="button"
                              className="employee-salary-pay-action"
                              onClick={
                                () =>
                                  onPay?.(
                                    salary
                                  )
                              }
                              disabled={
                                [
                                  "PAID",
                                  "CANCELLED",
                                ].includes(
                                  String(
                                    paymentStatus
                                  ).toUpperCase()
                                )
                              }
                              title={
                                formatEmployeeLabel(
                                  paymentStatus
                                )
                              }
                            >

                              <FiDollarSign />

                            </button>

                          </div>

                        </td>

                      </tr>

                    );

                  }
                )
            }

          </tbody>

        </table>

      </div>


      {
        totalRecords >
        0
          ?
          (
            <EmployeePagination
              page={
                page
              }
              limit={
                limit
              }
              totalRecords={
                totalRecords
              }
              totalPages={
                totalPages
              }
              onPageChange={
                onPageChange
              }
              onLimitChange={
                onLimitChange
              }
            />
          )
          :
          null
      }

    </section>

  );

};


export default EmployeeSalaryTable;